// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3JrMl","row":"Node_row__2ZPJr","label":"Node_label__2ekmu","footer":"Node_footer__1T3G9"};